import ChevronRight from '@material-ui/icons/ChevronRight';
import PropTypes from 'prop-types';
import React from 'react';

const MenuChevron = () => (
  <ChevronRight
    style={{
      color: '#d9e1e1',
      fontSize: '35px',
      alignSelf: 'center'
    }}
  />
);

const AdTypeMenuItem = props => (
  <div
    data-testid={props.testId}
    className="ad-type-button"
    onClick={props.onClick}
    role="presentation"
  >
    <img alt="" className="ad-type-button_icon" src={props.iconSrc} />
    <div className="ad-type-button_text">
      <div className="ad-type-button_heading">{props.heading}</div>
      <span className="ad-type-button_subheading">{props.subheading}</span>
    </div>
    <MenuChevron />
  </div>
);

AdTypeMenuItem.propTypes = {
  heading: PropTypes.string.isRequired,
  iconSrc: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  subheading: PropTypes.string.isRequired,
  testId: PropTypes.string
};

AdTypeMenuItem.defaultProps = {
  testId: ''
};

export default AdTypeMenuItem;
